import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty'

import { jsonTryParse } from '../json'

/**
 * Replaces every quoted `"<name>"` string in a filter with the JSON of the token's value, so a number lands
 * unquoted and a string stays quoted. A token whose value is `undefined` is left in place; an absent or empty
 * token map returns the same `filter` object.
 */
export function replaceFilterTokens<T extends Record<string, any>>(
  filter: T,
  tokens?: Record<string, string | number | undefined>
): T {
  if (isEmpty(tokens)) return filter

  let filterString = JSON.stringify(filter)
  forEach(tokens, (value, name) => {
    if (value === undefined) return
    filterString = filterString.split(`"${name}"`).join(JSON.stringify(value))
  })
  return jsonTryParse(filterString)
}
